
import React from "react";
import "./ToggleSmall.css"
const ToggleSmallUI= ({state,toggleState}) =>{
    
return(
       <span  className="">
       
        <label   class="switchmutesmall "> 
 <input id="togglemute" checked={state} onChange={e=>toggleState(e.target.checked)}   type="checkbox"  
    /> 
   
  <span class="sliderlfmutesmall round"></span>
</label>
    
    </span>
    
)

}

export default ToggleSmallUI;

